<template>
    <div>
        <div class="container">
            <div class="flex justify-center w-screen h-screen">
                <div class="bg-white w-full md:h-1/3 md:w-1/3 text-black p-10 m-10 text-center">
                    <h1 class="text-2xl font-bold">{{ title }}</h1>
                    <p>
                        {{ description }}
                    </p>

                    <div class="text-center pt-20">
                        <slot>
                            <button class="btn btn-blue" @click="goHome()">Go home</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

<script>
export default {
    props: {
        title: String,
        description: String
    },

    methods: {
        goHome() {
            window.location.href = '/';
        }
    }
}
</script>